// biome-ignore lint/style/useImportType: legacy import, will be migrated
import {
  getG11nAndTranslationsFromServer,
  initializeApollo,
  TCustomGetServerSideProps,
} from '@crehana/next';
import { getFeatureFlag } from '@crehana/utils';

import { REGISTER_PAGE_KEY } from '../constants';
import locales from '../i18n';
// biome-ignore lint/style/useImportType: legacy import, will be migrated
import { IAppProps } from '../types';

const getServerSideProps: TCustomGetServerSideProps<IAppProps> = async ({
  req,
  query,
}) => {
  const apolloClient = initializeApollo({
    headers: req.headers,
    pageKey: REGISTER_PAGE_KEY,
  });

  const [g11nData, hideFacebookButton, hideFacebookLink] = await Promise.all([
    getG11nAndTranslationsFromServer({
      apolloClient,
      headers: req.headers,
      pageKey: REGISTER_PAGE_KEY,
      defaultTranslations: locales,
      includeMainFooter: false,
      includeMainMenu: false,
    }),
    getFeatureFlag(apolloClient, 'button_facebook_auth_hide'),
    getFeatureFlag(apolloClient, 'link_facebook_auth_hide'),
  ]);

  return {
    props: {
      ...g11nData,
      featureFlags: {
        hideFacebookButton,
        hideFacebookLink,
      },
      query,
      // NOTE: In the register page we don't have the organization slug but we need it to be sent to the app.
      organizationSlug: '',
    },
  };
};

export default getServerSideProps;
